var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 54,
    viewBox: "0 0 73 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#335F88",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 41,
    x: 1.5,
    y: 1.5,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.098 4.013l21.656 18.263a5 5 0 0 0 6.473-.022l21.33-18.24"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 39,
    r: 13,
    fill: "#46586A",
    stroke: "#FFF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 39,
    r: 11,
    fill: "#FFF",
    stroke: "#1D9F61",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D9F61",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M54 39.064L57.094 42 62 37"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#EA4335",
    transform: "translate(46 27)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#FFF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.667 7.89L8.465 15.09M15.667 15.091L8.465 7.889"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailError);
export default __webpack_public_path__ + "static/media/email-error.1bee7cf20fa73c487fbe6eb1aa6e481f.svg";
export { ForwardRef as ReactComponent };